// this is an autogenerated file from App/ChooseLocation/Admin/Locations/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_ChooseLocation_Admin_Locations($xid: String!, $user_id: uuid!) {
  app_admin_users_access(
    where: {
      organization_level: { _eq: "location" }
      xid: { _eq: $xid }
      user_id: { _eq: $user_id }
    }
    order_by: { organization_name: asc }
  ) {
    id: organization_id
    name: organization_name
    xid
  }
}

`